export default __webpack_public_path__ + "static/media/vialog-lt-regular.ffc65eb1.ttf";